var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 3.00004H20V0.333374H17.3333V3.00004H6.66667V0.333374H4V3.00004H2.66667C1.18667 3.00004 0.0133333 4.20004 0.0133333 5.66671L0 24.3334C0 25.8 1.18667 27 2.66667 27H21.3333C22.8 27 24 25.8 24 24.3334V5.66671C24 4.20004 22.8 3.00004 21.3333 3.00004ZM21.3333 24.3334H2.66667V9.66671H21.3333V24.3334ZM5.33333 12.3334H12V19H5.33333V12.3334Z",
    fill: "#1D253C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon-calendar.06f814b427c77c1dc2a3e23d858bff1d.svg";
export { ForwardRef as ReactComponent };